import React, { useRef, useState, useEffect } from "react";
import "./SignaturePad.css"; // Import your CSS file for styling

const SignaturePad = ({ onStartDrawing, onClearDrawing }) => {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    // Set canvas size
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    // Basic drawing style
    context.lineCap = "round";
    context.strokeStyle = "#000";
    context.lineWidth = 2;
  }, []);

  const startDrawing = (e) => {
    const ctx = canvasRef.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(getX(e), getY(e));
    onStartDrawing();
    setIsDrawing(true);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    const ctx = canvasRef.current.getContext("2d");
    ctx.lineTo(getX(e), getY(e));
    ctx.stroke();
  };

  const endDrawing = () => {
    setIsDrawing(false);
  };

  const clearCanvas = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    onClearDrawing();
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  };

  const getX = (e) => {
    if (e.touches) {
      return (
        e.touches[0].clientX - canvasRef.current.getBoundingClientRect().left
      );
    }
    return e.clientX - canvasRef.current.getBoundingClientRect().left;
  };

  const getY = (e) => {
    if (e.touches) {
      return (
        e.touches[0].clientY - canvasRef.current.getBoundingClientRect().top
      );
    }
    return e.clientY - canvasRef.current.getBoundingClientRect().top;
  };

  return (
    <div className="signature-pad">
      <canvas
        ref={canvasRef}
        onMouseDown={startDrawing}
        onMouseMove={draw}
        onMouseUp={endDrawing}
        onMouseLeave={endDrawing}
        onTouchStart={startDrawing}
        onTouchMove={draw}
        onTouchEnd={endDrawing}
      />
      <button onClick={clearCanvas}>Clear</button>
    </div>
  );
};

export default SignaturePad;
